import type { ProgramContentObject } from 'models';
import { usePermissions } from 'permissions';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix according to result of #67489
import Rating from 'features/programs/feed/Rating';
import { useReloadContentObjectMutation } from '../../../queries';
import { CommentCount } from '../comment-count';
import { StatusBarLayout } from '../status-bar-layout';

type P = {
  item: ProgramContentObject;
  onShowComments?: () => void;
};

const ProgramStatusBar = ({ item, onShowComments }: P) => {
  const { commentsCount, evaluation, evaluationRatingAverage, id } = item;
  const ratingAverage = evaluationRatingAverage ?? '';

  const { canRateProgramObject, canViewRating: canViewRatingFunction } = usePermissions();

  const canRate = canRateProgramObject({ contentObject: item });
  const canViewRating = canViewRatingFunction({ contentObject: item });
  const { mutateAsync: reloadObject } = useReloadContentObjectMutation();

  const rating = (
    <Rating
      canRate={canRate}
      canViewRating={canViewRating}
      contentObjectId={id}
      onRate={async () => reloadObject({ filter: { id } })}
      rating={evaluation ?? 0}
      ratingAverage={ratingAverage}
    />
  );

  const isCommentsVisible = commentsCount > 0;

  return isCommentsVisible || canViewRating || canRate ? (
    <StatusBarLayout
      left={
        <>
          {canViewRating ? rating : null}
          {isCommentsVisible ? (
            <div className="program-status-bar">
              <CommentCount count={commentsCount} onShowComments={onShowComments} />
            </div>
          ) : null}
        </>
      }
      right={<>{canRate ? rating : null}</>}
    />
  ) : null;
};

export default ProgramStatusBar;
